import * as React from 'react';
var SvgStopperTriangleRounded = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.004 4.6c.313-.824 1.46-.79 1.75.043 1.9 5.45 3.24 7.432 5.14 12.885.42 1.21-.458 2.472-1.7 2.472H7.826c-1.287 0-2.17-1.343-1.698-2.583L11.004 4.6Z"
}));
export default SvgStopperTriangleRounded;